import React from "react";

interface Feature {
  title: string;
  description: string;
  icon: string;
}

const features: Feature[] = [
  {
    title: "数据通信",
    description: "基于EventBus的发布订阅模式，实现Host与Remote应用之间的双向数据通信",
    icon: "📡",
  },
  {
    title: "组件复用",
    description: "Host暴露UserInfo组件供Remote应用使用，实现跨应用的组件共享",
    icon: "🧩",
  },
  {
    title: "主题复用",
    description: "Host暴露theme.css主题配置，3个Remote应用共享统一的青色科技主题样式",
    icon: "🎨",
  },
  {
    title: "远程模块加载",
    description: "动态加载3个Remote应用（orderCancel、orderModify、orderCheck），实现按需加载",
    icon: "🚀",
  },
  {
    title: "独立部署",
    description: "Host和3个Remote应用可独立构建、独立部署，互不影响",
    icon: "📦",
  },
  {
    title: "运行时集成",
    description: "Remote应用在运行时动态集成到Host，无需重新构建Host应用",
    icon: "⚡",
  },
  {
    title: "依赖共享",
    description: "通过shared配置共享React和React-DOM，避免重复打包，减少体积",
    icon: "🔗",
  },
  {
    title: "类型安全",
    description: "通过dts配置生成TypeScript类型定义，确保跨应用的类型安全",
    icon: "🛡️",
  },
  {
    title: "工具函数库共享",
    description: "Host暴露utils工具函数库（formatDate、generateId、debounce等），供Remote应用复用",
    icon: "🔧",
  },
];

const FeatureList: React.FC = () => {
  return (
    <div className="glass-card" style={{ padding: "24px", marginBottom: "20px" }}>
      <div className="text-primary glow-text" style={{ fontSize: "24px", marginBottom: "20px", marginTop: 0, marginLeft: 0, marginRight: 0, fontWeight: "600" }}>
        模块联邦主要功能
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))", gap: "16px" }}>
        {features.map((feature, index) => (
          <div
            key={index}
            className="glass-card-light"
            style={{
              padding: "16px",
              borderColor: "var(--color-border-default)",
              transition: "all 0.3s ease",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.borderColor = "var(--color-border-glow)";
              e.currentTarget.style.boxShadow = "0 0 15px var(--color-glow)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.borderColor = "var(--color-border-default)";
              e.currentTarget.style.boxShadow = "none";
            }}
          >
            <div style={{ display: "flex", alignItems: "flex-start", gap: "12px" }}>
              <span style={{ fontSize: "32px", lineHeight: "1" }}>{feature.icon}</span>
              <div style={{ flex: 1 }}>
                <div className="text-accent" style={{ fontSize: "18px", marginBottom: "8px", marginTop: 0, marginLeft: 0, marginRight: 0, fontWeight: "600" }}>
                  {feature.title}
                </div>
                <div className="text-secondary" style={{ fontSize: "14px", lineHeight: "1.6", margin: 0 }}>
                  {feature.description}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FeatureList;
